// @flow

import React from 'react'

type PropTypes = {
  score: number,
  linkUrl?: ?string,
  nolink?: boolean,
}

const MAX_SCORE = 5

export default (props: PropTypes) => {
  let score = props.score
  let starIndex = MAX_SCORE
  const stars = []
  while (starIndex > 0) {
    if (score >= 1) {
      stars.push(
        <i key={`star${starIndex}`} className="fa fa-star mr2 is-checked" />,
      )
    } else if (score >= 0.5) {
      stars.push(
        <span key={`star${starIndex}`} className="star-harf fa fa-star">
          <i className="fa fa-star mr2 is-default" />
        </span>,
      )
    } else {
      stars.push(
        <i key={`star${starIndex}`} className="fa fa-star mr2 is-default" />,
      )
    }
    score -= 1.0
    starIndex -= 1
  }

  if (props.nolink) {
    return <span href={props.linkUrl}>{stars.map(s => s)}</span>
  }

  return <a href={props.linkUrl}>{stars.map(s => s)}</a>
}



// WEBPACK FOOTER //
// ./src/components/shared/ReputationStar/index.jsx